module.exports = __webpack_public_path__ + "3b01e146dfcfdf060b1500c97db4d995.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Carousel/images/5.jpg
// module id = ./src/components/Carousel/images/5.jpg
// module chunks = 0